import { mapGetters } from 'vuex'

export const authComputed = {
  ...mapGetters('users', [
    'loggedIn',
    'getUserAccounts',
    'isUserAdmin',
    'getCustomerWconfig',
    'getCustomerFaasKeys',
    'getCustomerMessagingDataKeys',
    'getCustomerProfile',
    'getShowSpinner'
  ])
}

export const reportsComputed = {
  ...mapGetters('admin', [
    'getAdminSummaryReports',
  ])
}
